import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    midbanner: null,
};

export const midbannerSlice = createSlice({
    name: "midbanner",
    initialState,
    reducers: {
        updateMidBanner: (state, action) => {
            state.midbanner = action.payload;
        },
        clearMidBanner: (state) => {
            state.midbanner = null;
        },        
    },
});

export const { updateMidBanner, clearMidBanner } = midbannerSlice.actions;

export default midbannerSlice.reducer;
